<template>
  <section :class="`resources fg-will-change ${resource.color}`">
    <div container>
      <div grid="row wrap">
        <div column="12">
          <hr class="_mbs" v-if="index > 0">
          <div class="content-wrap">
            <h3>{{resource.cat}}</h3>
            <a tabindex="0" @click.prevent="showAll = !showAll" v-if="resource.resources">
              <span v-if="!showAll">VIEW ALL</span>
              <span v-else>VIEW FEWER</span>
            </a>
          </div>
        </div>
        <div column="xs-12 s-12 m-6" v-for="(resource, i) in resourcesToShow" :key="i">
          <div class="resource-wrap">
            <div class="resource">
              <a class="file-type" :href="resource.url ? resource.url : resource.filePath" :download="!resource.url ? '' : false">
                <app-report-icon/>
                <span class="filename">{{ellipse(resource.fileName)}}</span>
                <span class="download btn-svg" aria-label="Download File">
                  <app-dl-icon/>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import ellipse from '@mixins/ellipse'
  import AppReportIcon from '@atoms/ReportIcon.vue'
  import AppDlIcon from '@atoms/DownloadIcon.vue'

  export default {
    data() {
      return { showAll: false }
    },
    props: { resource: Object, index: Number },
    components: { AppDlIcon, AppReportIcon },
    mixins: [ellipse],
    computed: {
      resourcesToShow() {
        if (this.showAll) {
          return this.resource.resources
        } else {
          return this.resource.resources.slice(0, 8)
        }
      }
    },
    methods: {
      viewAll() {}
    }
  }
</script>
<style>
section.resources {
  padding-bottom: 1rem;
  padding-top: 2rem;
}
</style>
